import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../components/public/Navbar.jsx';
import Footer from '../components/public/Footer.jsx';
import HomeEventPopup from '../components/public/HomeEventPopup.jsx';
import FontSizeFloatingButton from '../components/public/FontSizeFloatingButton.jsx';
import PseFloatingButton from '../components/public/PseFloatingButton.jsx';
import WhatsAppFloatingButton from '../components/public/WhatsAppFloatingButton.jsx';
import { usePageViewAnalytics } from '../hooks/usePageViewAnalytics.js';
import { useGoogleAnalytics } from '../hooks/useGoogleAnalytics.js';

export default function PublicLayout() {
  const { pathname } = useLocation();
  usePageViewAnalytics();
  useGoogleAnalytics();

  const isHome = pathname === '/';

  return (
    <div className="flex min-h-screen flex-col overflow-x-hidden bg-page-dark bg-fixed">
      {isHome ? <HomeEventPopup /> : null}
      <Navbar />
      <main className="relative flex-1">
        <div
          key={pathname}
          className="animate-page-enter motion-reduce:animate-none motion-reduce:opacity-100 motion-reduce:transform-none"
        >
          <Outlet />
        </div>
      </main>
      <Footer />
      <FontSizeFloatingButton />
      <PseFloatingButton />
      <WhatsAppFloatingButton />
    </div>
  );
}
